import { createContext, useContext, useState } from "react"

export const PaymentContext = createContext(null)

export const PaymentProvider = ({ children }) => {

    const [plans, setPlans] = useState([])
    const [subscription, setSubscription] = useState(null)


    return (
        <PaymentContext.Provider
            value={{ plans, setPlans, subscription, setSubscription }}
        >
            {children}
        </PaymentContext.Provider>
    )
}

export const usePaymentContext = () => {
    const context = useContext(PaymentContext)

    if (!context) {
        throw new Error('usePaymentContext must be used within a PaymentProvider')
    }

    return context
}